import React, { useState } from 'react'
import { Tooltip } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import ViewReportButton from '../../../../components/ViewReportButton'
import Reports from './reports'
import {
  LockReason,
  AssessmentInfoCard,
  AssessmentInfo,
  AssessmentTitle,
  AssessmentSubtitle,
  TimeInfo,
  DaysLeft,
  DeadlineInfo,
  DeadlineLabel,
  DeadlineTime,
  TakeAssessmentButton,
  CompletedAssessmentCard,
  CompletedInfo,
  CompletedDate,
  CompletedLabel,
  CompletedDateTime,
} from '../../Style'

const AssessmentTable = ({
  activeTab,
  activeAssessments,
  completedAssessments,
  handleTakeAssessment,
  handleViewReport,
  activeAssessmentsLoading,
  completedAssessmentsLoading,
  pdfLoading,
  pdfLoadingId
}) => {
  const calculateDaysLeft = endTime => {
    const now = new Date()
    const end = new Date(endTime)
    const timeDiff = end - now
    const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
    return `${days} days left`
  }

  const formatDateTime = dateTime => {

    // Create a date object from the input datetime
    const istDate = new Date(dateTime)


  

    // Array of day names
    const days = [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thur',
      'Fri',
      'Sat',
    ]

    // Get the day name
    const dayName = days[istDate.getDay()]

    // Format the date: Day, DD Month YYYY, HH:MM AM/PM
    const formattedDate = istDate.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })

    // Format the time with AM/PM
    const formattedTime = istDate.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })

    // Combine everything into a readable format
    return `${dayName}, ${formattedDate}, ${formattedTime}`

  }

  if (
    (activeTab === 'active' && activeAssessmentsLoading) ||
    (activeTab === 'completed' && completedAssessmentsLoading)
  ) {
    return <LoadingSpinner />
  }

  if (activeTab === 'reports') {
    return <Reports />
  }

  return (
    <>
      {activeTab === 'active' &&
        activeAssessments?.map(assessment => (
          <AssessmentInfoCard key={assessment.id}>
            <AssessmentInfo>
              <AssessmentTitle>
                {assessment.title || assessment.name}
              </AssessmentTitle>
              <AssessmentSubtitle>Type: {assessment.type}</AssessmentSubtitle>
            </AssessmentInfo>
            <TimeInfo>
              <DaysLeft>{calculateDaysLeft(assessment.endTime)}</DaysLeft>
              <DeadlineInfo>
                <DeadlineLabel>Start Time:</DeadlineLabel>
                <DeadlineTime>
                  {formatDateTime(assessment.startTime)}
                </DeadlineTime>
                <DeadlineLabel>End Time:</DeadlineLabel>
                <DeadlineTime>
                  {formatDateTime(assessment.endTime)}
                </DeadlineTime>
              </DeadlineInfo>
              <Tooltip title={assessment.subscriptionLockReason || ''}>
                {/* Wrapped so the tooltip still fires over a disabled button —
                    a disabled control emits no pointer events of its own. */}
                <span>
                  <TakeAssessmentButton
                    onClick={() => handleTakeAssessment(assessment)}
                    disabled={Boolean(assessment.subscriptionLocked)}
                    aria-disabled={Boolean(assessment.subscriptionLocked)}
                    aria-label={
                      assessment.subscriptionLocked
                        ? `Locked: ${assessment.subscriptionLockReason}`
                        : `Take ${assessment.title || assessment.name}`
                    }
                  >
                    {assessment.subscriptionLocked ? (
                      <>
                        <LockOutlined aria-hidden="true" /> Locked
                      </>
                    ) : (
                      'Take Assessment'
                    )}
                  </TakeAssessmentButton>
                </span>
              </Tooltip>
              {assessment.subscriptionLocked && (
                <LockReason role="note">
                  {assessment.subscriptionLockReason}
                </LockReason>
              )}
            </TimeInfo>
          </AssessmentInfoCard>
        ))}

      {activeTab === 'completed' &&
        completedAssessments?.map(assessment => (
          <CompletedAssessmentCard key={assessment.id}>
            <CompletedInfo>
              <AssessmentInfo>
                <AssessmentTitle>{assessment.title}</AssessmentTitle>
                <AssessmentSubtitle>Type: {assessment.type}</AssessmentSubtitle>
              </AssessmentInfo>
              <CompletedDate>
                <CompletedLabel>Completed on</CompletedLabel>
                <CompletedDateTime>
                  {formatDateTime(assessment.submittedAt)}
                </CompletedDateTime>
              </CompletedDate>
              {/* <ViewReportButton
                onClick={() =>
                  handleViewReport(assessment.assessment_assigned_id)
                }
                disabled={
                  pdfLoading
                }
                loading={pdfLoading}
                endTime={assessment.endTime}
                aria-label={
                  pdfLoading ? 'Generating PDF report...' : 'View Report'
                }
              /> */}
              <ViewReportButton
                onClick={() => handleViewReport(assessment.assessment_assigned_id)}
                disabled={false}
                loading={pdfLoading}
                loadingId={pdfLoadingId}
                id={assessment.assessment_assigned_id}
                endTime={assessment.endTime}
                aria-label={
                  pdfLoading && pdfLoadingId === assessment.assessment_assigned_id
                    ? 'Generating PDF report...'
                    : 'View Report'
                }
              />
            </CompletedInfo>
          </CompletedAssessmentCard>
        ))}
    </>
  )
}

export default AssessmentTable
